const request = (state = null, action) => {
    switch (action.type) {
        case "SET":
            return action.payload
        case "REMOVE":
            return null
        default:
            return state
    }
}

export default request;